import { Theme } from '@emotion/react'
import { Color, SxProps } from '@mui/material'

export const makeSx = <T extends { [key: string]: SxProps<Theme> }>(arg: T): T => arg

export const makePalette = <T extends Record<string, Partial<Color>>>(styles: T): T => styles
